import axios from 'axios';
/**
 * Client to make API calls to Kibsi services.
 * Implement per entity type by defining the REST paths.
 */
export class KibsiClient {
    logger;
    servicePath;
    baseURL;
    /**
     * The Axios instance.
     * Use instanceWithLatestConfig() to ensure it is appropriately configured.
     */
    instance;
    constructor(params, servicePath) {
        this.logger = params.logger;
        this.servicePath = servicePath;
        this.baseURL = params.basePathTemplate.replace('{service}', this.servicePath);
        this.logger?.debug(`Client baseURL: ${this.baseURL}`);
        this.instance = axios.create({
            baseURL: this.baseURL,
            timeout: 10_000,
        });
        params.interceptors?.request?.forEach((req) => {
            this.instance.interceptors.request.use(...req);
        });
        params.interceptors?.response?.forEach((resp) => {
            this.instance.interceptors.response.use(...resp);
        });
    }
    /** HTTP methods */
    async post(path, entity, requestConfig) {
        this.logger?.debug(`${this.servicePath} client POST ${path}`);
        const result = await this.instance.post(path, entity, requestConfig);
        this.logger?.debug(`Status: ${result.status}`);
        return result.data;
    }
    async get(path, requestConfig) {
        this.logger?.debug(`${this.servicePath} client GET ${path}`);
        const result = await this.instance.get(path, requestConfig);
        this.logger?.debug(`Status: ${result.status}`);
        return result.data;
    }
    async put(path, entity, requestConfig) {
        this.logger?.debug(`${this.servicePath} client PUT ${path}`);
        const result = await this.instance.put(path, entity, requestConfig);
        this.logger?.debug(`Status: ${result.status}`);
        return result.data;
    }
    async patch(path, entity, requestConfig) {
        this.logger?.debug(`${this.servicePath} client PATCH ${path}`);
        const result = await this.instance.patch(path, entity, requestConfig);
        this.logger?.debug(`Status: ${result.status}`);
        return result.data;
    }
    async del(path, requestConfig) {
        this.logger?.debug(`${this.servicePath} client DELETE ${path}`);
        const result = await this.instance.delete(path, requestConfig);
        this.logger?.debug(`Status: ${result.status}`);
    }
}
//# sourceMappingURL=base.js.map